import { collection, setDoc, getDocs, deleteDoc, doc, serverTimestamp } from "firebase/firestore"
import { db } from "./firebase"

const AiInterviewTranscriptService = {
    _roomId: null,

    async startSession(roomId) {
        this._roomId = roomId
        const col = collection(db, "rooms", roomId, "transcripts")
        const existing = await getDocs(col)
        await Promise.all(existing.docs.map((d) => deleteDoc(doc(db, "rooms", roomId, "transcripts", d.id))))
    },

    async addMessage(role, text) {
        if (!this._roomId) return
        await setDoc(doc(db, "rooms", this._roomId, "transcripts", Date.now().toString()), {
            sender: role,
            text,
            timestamp: serverTimestamp(),
        })
    },

    async endSession() {
        if (!this._roomId) return
        this._roomId = null
    },

    reset() {
        this._roomId = null
    },
}

export default AiInterviewTranscriptService